import {action, observable} from 'mobx';
import { AxiosRequestConfig } from 'axios';
import {
  createFacility,
  getFacilities,
  getFacilityById,
  updateFacility,
  updateFacilityStatus,
  getRatingFacilitiesReport,
  getFacilityResponses,
  facilitiesBrnachRatingStatistics,
  facilitiesAreaRatingStatistics,
  facilityStatistics,
  exportBranchFacilitiesRatingSheet,
  exportAreaFacilitiesRatingSheet,
  exportFacilityResponses,
} from '../../axios/facilitiesRequests';
import Connections from '../../connections';
import {uploadFileURL} from '../../axios/requests';
import {convertCountriesToISOCodeString} from '../../constants/countries';
import {DefaultLanguage} from '../../constants/languages';
import {getHeader} from '../../helperFunctions/getHeader';
import {translate} from '../../helperFunctions/translation';
import {uploadFile} from '../../helperFunctions/uploadService';
import {ICountry} from '../storeInterfaces/authInterface';
import {
  ICreateFacility,
  IFacility,
  FacilityResponse,
  BranchFacilitiesStatistics,
  IRatingFacilitiesReportsOptions,
  IFacilityResponsesListOptions,
  AreaFacilitiesStatistics,
  FacilityStatistics,
  MediaTypes,
  MediaFile,
  FilteredGallery,
} from '../storeInterfaces/facilitiesInterface';
import {isImageArray} from '../storeInterfaces/featuredArticlesStore';
import {RequestStatus} from 'mobx-store';
import {firebaseConfig} from "../../connections/Firebase/environment";
import {FirebaseDynamicLinks} from "firebase-dynamic-links";
import * as FileSaver from "file-saver";

export class FacilityStore {

    androidInfo: any;

    iosInfo: any;

    constructor() {
        this.androidInfo = {
            androidPackageName: firebaseConfig.android.packageName,
        };
        this.iosInfo = {
            iosBundleId: firebaseConfig.iOS.bundleId,
            iosAppStoreId: firebaseConfig.iOS.appstoreId,
        };
    }

  @observable facilitiesList: any[] = [];

  @observable selectedFacility = {
  };

  @observable facilityResponseList: FacilityResponse[] = [];

  @observable branchFacilitiesStatistics: BranchFacilitiesStatistics = { labels: [] , points: []} ;

  @observable areaFacilitiesStatistics: AreaFacilitiesStatistics = { labels: [] , points: []} ;

  @observable facilityStatistics: FacilityStatistics = { labels: [] , points: [] };

  @observable facilityQR: string = '';

  @observable loading = false;

  @observable getFacilitiesRequestStatus: RequestStatus = RequestStatus.IDLE;

  private static restructureFacility(facility: IFacility): any {
    return {
      name: facility.name,
      facilityId: facility.facilityId,
      branchId: facility.branch.branchId,
      branchTitle: facility.branch.title,
      isActive: facility.isActive,
      imageUrl: (facility.imageUrl ? [{
        imageUrl: facility.imageUrl,
      }] : []),
      facilityCategory: facility.facilityCategory.facilityCategoryId,
      facilityGroup: facility.facilityGroup?.FacilityGroupId,
      facilityArea: facility.facilityArea ? facility.facilityArea.facilityAreaId : -1,
      facilityForm: facility.questionsFormId,
      images: facility.media?.filter((file) => (file.mediaType === MediaTypes.Image)) || [],
      videos: facility.media?.filter((file) => (file.mediaType === MediaTypes.Video)) || [],
      images360: facility.media?.filter((file) => (file.mediaType === MediaTypes.Image360)) || [],
    };
  }

  private static restructureCreateFacility(facility: ICreateFacility): any {
    console.log('img >>>  ', facility.images);
    console.log('vid >>>  ', facility.videos);
    console.log('img360 >>>  ', facility.images360);
    return {
      facilityCategoryId: facility.facilityCategory,
      facilityGroupId: facility.facilityGroup,
      name: facility.name,
      imageUrl: facility.imageUrl,
      branchId: facility.branchId,
      isActive: facility.isActive,
      availableCountries: facility.availableCountries,
      type: facility.facilityType,
      facilityAreaId: facility.facilityArea,
      images: facility?.images || [],
      videos: facility?.videos || [],
      images360: facility?.images360 || [],
    };
  }

  private async mapNewAndDeletedFromGallery(initGallery: MediaFile[], submittedFiles: any[]): Promise<FilteredGallery> {
    const deletedIds: number[] = [];
    const newFiles: any[] = [];
    submittedFiles.forEach((file) => {
      if (file.preview) {
        newFiles.push(file);
      } else {
        const findIndex = initGallery.findIndex((media) => media.mediaId === file.mediaId);
        if (findIndex !== -1) {
          initGallery.splice(findIndex, 1);
        }
      }
    });
    const newFilesLinks = await this.uploadFacilityMediaFiles(newFiles);
    initGallery.forEach((item) => deletedIds.push(item.mediaId));
    return {
      newFilesLinks,
      deletedIds,
    } as FilteredGallery;
  }

  private static restructureUpdateFacility(
    facility: ICreateFacility, filteredImages: FilteredGallery,
    filteredVideos: FilteredGallery, filteredImages360: FilteredGallery,
  ): any {
    return {
      facilityCategoryId: facility.facilityCategory,
      facilityGroupId: facility.facilityGroup,
      name: facility.name,
      imageUrl: facility.imageUrl,
      branchId: facility.branchId,
      isActive: facility.isActive,
      availableCountries: facility.availableCountries,
      type: facility.facilityType,
      facilityAreaId: facility.facilityArea,
      newImages: filteredImages.newFilesLinks,
      deletedImagesIds: filteredImages.deletedIds,
      newVideos: filteredVideos.newFilesLinks,
      deletedVideosIds: filteredVideos.deletedIds,
      newImages360: filteredImages360.newFilesLinks,
      deletedImages360Ids: filteredImages360.deletedIds,
    };
  }

  @action
  public async getFacilities(countries: ICountry[], facilityType: string,
    searchQuery?: string, langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      this.getFacilitiesRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
        status: 'all',
        facilityType,
        query: searchQuery,
      };

      const config = {
        ...getHeader(langCode), params,
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getFacilities, config);
      this.facilitiesList = this.restructureFacilitiesList(response.data);
      this.getFacilitiesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getFacilitiesRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
}
   @action public async getRatingFacilitiesReport(options : IRatingFacilitiesReportsOptions, langCode : string = DefaultLanguage): Promise < void > {
        try {
            this.loading = true;
            this.getFacilitiesRequestStatus = RequestStatus.LOADING;

            const availableCountries = convertCountriesToISOCodeString(options.availableCountries);

            const params = {
                availableCountries,
                areaId: options.areaId ? options.areaId : null,
                categoryId: options.categoryId ? options.categoryId : null,
                branchId: options.branchId ? options.branchId : null,
                query: options.query ? options.query : null,
                rating: options.rating ? options.rating : null
            };

            const config = {
                ...getHeader(langCode),
                params
            };

            const response = await Connections.wadiDeglaAxios.httpGet(getRatingFacilitiesReport, config);

            this.facilitiesList = this.restructureRatingFacilitiesReportList(response.data);
            this.getFacilitiesRequestStatus = RequestStatus.SUCCESS;
        } catch (error) {
            this.getFacilitiesRequestStatus = RequestStatus.FAILED;
            console.log(error);
        } finally {
            this.loading = false;
        }
    }
    @action public async getFacilityResponsesList(facilityId : number, options : IFacilityResponsesListOptions, langCode : string = DefaultLanguage,): Promise < void > {
        try {
            this.loading = true;
            this.getFacilitiesRequestStatus = RequestStatus.LOADING;

            const availableCountries = convertCountriesToISOCodeString(options.availableCountries);

            const params = {
                availableCountries,
                from: options.from ? new Date(options.from) : null,
                to: options.to ? new Date(options.to) : null,
                rating: options.rating ? options.rating : null
            };

            const config = {
                ...getHeader(langCode),
                params
            };

            const response = await Connections.wadiDeglaAxios.httpGet(getFacilityResponses(facilityId), config);

            this.facilityResponseList = response.data;
            this.getFacilitiesRequestStatus = RequestStatus.SUCCESS;

        } catch (error) {
            this.getFacilitiesRequestStatus = RequestStatus.FAILED;
            Promise.reject();
        } finally {
            this.loading = false;
        }
    }

    @action public async exportFacilityResponsesList(
      facilityId: number, options: IFacilityResponsesListOptions, langCode: string = DefaultLanguage,
    ): Promise <void> {
        try {
            this.loading = true;
            this.getFacilitiesRequestStatus = RequestStatus.LOADING;

            const availableCountries = convertCountriesToISOCodeString(options.availableCountries);

            const params = {
              availableCountries,
              from: options.from ? new Date(options.from) : null,
              to: options.to ? new Date(options.to) : null,
              rating: options.rating ?? null,
            };
            
            const config: AxiosRequestConfig = {
                ...getHeader(langCode),
                params,
                responseType: 'blob',
            };

            const response = await Connections.wadiDeglaAxios.httpGet(exportFacilityResponses(facilityId), config);

            await FileSaver.saveAs(response, `facility#${facilityId}_responses`);
            this.getFacilitiesRequestStatus = RequestStatus.SUCCESS;
        } catch (error) {
            this.getFacilitiesRequestStatus = RequestStatus.FAILED;
            Promise.reject();
        } finally {
            this.loading = false;
        }
    }

    @action public async getFacilitiesBrnachRatingStatistics(branchId: number, from?: Date , to?: Date): Promise < any > {
        try {
            this.loading = true;
            let params = {};

            if (from && to) {
             params = { from,  to };
            }
            const response = await Connections.wadiDeglaAxios.httpGet(facilitiesBrnachRatingStatistics(branchId), {params});
            this.branchFacilitiesStatistics = this.restructureFacilitiesBranchChart(response.data);

        } catch (error) {
           throw error;
        } finally {
            this.loading = false;
        }
    }

    @action public async exportBranchFacilitiesRatings(branchId: number, branchTitle: string): Promise <any> {
        try {
            this.loading = true;
            const response = await Connections.wadiDeglaAxios.httpGet(
              exportBranchFacilitiesRatingSheet(branchId), {responseType: "blob"},
            );
            
            await FileSaver.saveAs(response, `#${branchId}_${branchTitle}_statistics`);
        } catch (error) {
           throw error;
        } finally {
            this.loading = false;
        }
    }

    @action public async getFacilitiesAreaRatingStatistics(branchId: number, areaId: number, from?: Date, to?: Date): Promise < any > {
        try {
            this.loading = true;
            let params = {};

            if (from && to) {
             params = { from,  to };
            }
            const response = await Connections.wadiDeglaAxios.httpGet(facilitiesAreaRatingStatistics(branchId , areaId), {params});
            this.areaFacilitiesStatistics = this.restructureFacilitiesBranchChart(response.data);

        } catch (error) {
           throw error;
        } finally {
            this.loading = false;
        }
    }

    @action public async exportAreaFacilitiesRatings(
      branchId: number, areaId: number, areaTitle: string,
    ): Promise <any> {
        try {
            this.loading = true;
            const response = await Connections.wadiDeglaAxios.httpGet(
              exportAreaFacilitiesRatingSheet(branchId, areaId), {responseType: "blob"},
            );

            await FileSaver.saveAs(response, `#${areaId}_${areaTitle}_statistics`);
        } catch (error) {
           throw error;
        } finally {
            this.loading = false;
        }
    }

    @action public async getFacilityRatingStatistics(facilityId: number, from?: Date, to?: Date): Promise < any > {
        try {
            this.loading = true;
            let params = {};

            if (from && to) {
             params = { from,  to };
            }
            const response = await Connections.wadiDeglaAxios.httpGet(facilityStatistics(facilityId), {params});
            this.facilityStatistics = this.restructureFacilitiesBranchChart(response.data);

        } catch (error) {
           throw error;
        } finally {
            this.loading = false;
        }
    }


  @action.bound public async createFacility(newFacility : ICreateFacility, langCode : string = DefaultLanguage): Promise < any > {
    return new Promise<void>(async (res, rej) => {
      try {
        if (isImageArray(newFacility.imageUrl)) {
          newFacility.imageUrl = await this.uploadSingleImage(newFacility.imageUrl);
        }
        if (isImageArray(newFacility.images)) {
          newFacility.images = await this.uploadFacilityMediaFiles(newFacility.images);
        }
        if (isImageArray(newFacility.videos)) {
          newFacility.videos = await this.uploadFacilityMediaFiles(newFacility.videos);
        }
        if (isImageArray(newFacility.images360)) {
          newFacility.images360 = await this.uploadFacilityMediaFiles(newFacility.images360);
        }

        const response = await Connections.wadiDeglaAxios.httpPost(
          createFacility, FacilityStore.restructureCreateFacility(newFacility), getHeader(langCode),
        );
        res(response.data.facilityId);
      } catch (error) {
        rej(error);
      }
    });
}

    @action.bound public async getFacilityById(id : number, langCode : string = DefaultLanguage): Promise < any > {
        try {
            this.loading = true;
            const response = await Connections.wadiDeglaAxios.httpGet(getFacilityById(id), getHeader(langCode));
            console.log('before restructure ==>', response.data);
            this.selectedFacility = FacilityStore.restructureFacility(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false;
        }
    }

  @action.bound
  public async updateFacility(updatedFacility: any, facilityId: number,
    initImagesGallery: MediaFile[], initVideosGallery: MediaFile[], initImages360Gallery: MediaFile[],
    langCode: string = DefaultLanguage,
  ): Promise<any> {
    try {
      updatedFacility.imageUrl = await this.uploadSingleImage(updatedFacility.imageUrl);
      const filteredImages = await this.mapNewAndDeletedFromGallery(initImagesGallery, updatedFacility.images || []);
      const filteredVideos = await this.mapNewAndDeletedFromGallery(initVideosGallery, updatedFacility.videos || []);
      const filteredImages360 = await this.mapNewAndDeletedFromGallery(initImages360Gallery, updatedFacility.images360 || []);

      const restructuredFacility = FacilityStore.restructureUpdateFacility(
        updatedFacility, filteredImages, filteredVideos, filteredImages360,
      );
      await Connections.wadiDeglaAxios.httpPut(updateFacility(facilityId), restructuredFacility, getHeader(langCode));
    } catch (error) {
      console.log(error);
    }
  }
  private restructureFacilitiesList(facilities: any[]): any[] {
    return facilities.map((facility) => ({
      ...facility,
      questionsForm: facility.questionsForm ? facility.questionsForm.questionsFormId : undefined,
      branchTitle: facility.branch.title,
      edit: translate('facilitiesListEditButton', {
      }),
      generate: 'Generate',
      editForm: 'Edit Form',
    }));
  }

    @action.bound public async updateFacilityStatus(index : number, updatedFacilityStatus : boolean): Promise < any > {
        try {
            const response = await Connections.wadiDeglaAxios.httpPut(updateFacilityStatus(this.facilitiesList[index].facilityId), {isActive: updatedFacilityStatus});
            console.log(response);
            this.facilitiesList[index].isActive = (updatedFacilityStatus);
            this.facilitiesList = this.facilitiesList.slice();
        } catch (error) {
            console.log(error);
        }
    }

    @action.bound public async getFacilityQR(id : number, langCode : string = DefaultLanguage): Promise < void > {
        try {
            this.facilityQR = await this.creatDynamicLink(id);
            // const response = await Connections.wadiDeglaAxios.httpGet(getFacilityQR(id), getHeader(langCode));
            // this.facilityQR = response.data.image;
        } catch (error) {
            console.log(error);
        }
    }
    @action.bound public async creatDynamicLink(id:any){

        const webKey=firebaseConfig.apiKey;
        const portalURL=firebaseConfig.PORTAL_URL;
        const dynamicLinkPrefix=firebaseConfig.DYNAMIC_LINK_PREFIX;

        const args={
            redirect:"redirectScannedQRScreen",
            entityId: `${id}`,
            params: ``,
        };
        const link = `${portalURL}?redirect=${args.redirect}${args.entityId ? `&entityId=${args.entityId}` : ""}${args.params ? `&params=${JSON.stringify(args.params)}` : ""}`;


        const firebaseDynamicLinks = new FirebaseDynamicLinks(webKey);



        const { shortLink } = await firebaseDynamicLinks.createLink({
            dynamicLinkInfo: {
                link: encodeURI(link),
                domainUriPrefix: dynamicLinkPrefix,
                androidInfo: this.androidInfo,
                iosInfo: this.iosInfo,
            },
            suffix: {
                option: "UNGUESSABLE",
            },
        });
        var QRCode = require('qrcode')
        const qr =   QRCode.toDataURL(shortLink, {
            errorCorrectionLevel: "Q",
            version: 10, // qr size
        });
        console.info(shortLink)
        return qr;
    }

    private restructureFacilitiesBranchChart(response : any[]): BranchFacilitiesStatistics {
        const labels: string[] = ['0'];
        const points: number[] = [5];
        console.log('response', response);
        response.forEach(fbrs => {
            labels.push(`${
                fbrs.day
            }/${
                fbrs.month
            }/${
                fbrs.year
            }`);
            points.push(+ fbrs.facilitiesRating);
        });
        return {labels, points};
    }


    private restructureRatingFacilitiesReportList(facilities : any[]): any[]{
        try {
            const ratingFacilitiesReport = facilities.map((facility) => ({
                facilityId: facility.facilityId,
                name: facility.name,
                branchName: facility.branchName,
                areaName: facility.areaName,
                categoryName: facility.categoryName,
                facilityRatings: facility.facilityRatings
            }));
            return ratingFacilitiesReport;
        } catch (error) {
            throw error;
        }
    }

    private async uploadSingleImage(images : any[]) {
        const promises = [];
        const allImages: any[] = [];
        for (const image of images) {
            if (image.preview) {
                promises.push(uploadFile(uploadFileURL, image).then((res : any) => {
                    allImages.push(res.data.downloadURL);
                }),
                );
            } else {
                allImages.push(image.imageUrl);
            }
        }
        return Promise.all(promises).then(() => {
            console.log('done');
            return(allImages.length ? allImages[0] : null);
        }).catch((error) => {
            console.log('error');
            return(allImages.length ? allImages[0] : null);
        });
    }

  private uploadFacilityMediaFiles(mediaFiles: any[]) {
    const promises: Promise<any>[] = [];
    const uploadedLinks: string[] = [];
    mediaFiles.forEach((file) => {
      if (file.preview) {
        promises.push(
          uploadFile(uploadFileURL, file)
            .then((res: any) => {
              uploadedLinks.push(res.data.downloadURL);
            }),
        );
      } else {
        uploadedLinks.push(file);
      }
    });
    return Promise.all(promises)
      .then(() => uploadedLinks)
      .catch((error) => {
        console.error('Error uploading media', error);
        return uploadedLinks;
      });
  }
}
